import editMessageStyle from 'src/views/Settings/MessageView/EditMessage/editMessage.style';

const uploadImageFieldStyle = (theme) => ({
  ...editMessageStyle(theme),
});

export default uploadImageFieldStyle;
